{
    "Target1Label": "Ziel 1:",
    "Target1Placeholder": "fünfzehn",
    "Target2Label": "Ziel 2:",
    "Target2Placeholder": "30",
    "Target3Label": "Ziel 3:",
    "Target3Placeholder": "60",
    "Target4Label": "Ziel 4:",
    "Target4Placeholder": "90",
    "Target5Label": "Ziel 5:",
    "Target5Placeholder": "120",
    "Target6Label": "Ziel 6:",
    "Target6Placeholder": "300",
    "TargetUnit": "s",
    "ResetanswertargetsButtonLabel": "Antwortziele zurücksetzen",
    "ResetanswertargetsPrompt": "Möchten Sie wirklich alle 6 Schwellenwerteinstellungen für die Antwortdauer eingehender Anrufe auf ihre Standardwerte zurücksetzen?",
    "ResetanswertargetsPromptButtonConfirmLabel": "Bestätigen",
    "ResetanswertargetsPromptButtonCancelLabel": "Absagen",
    "AnswerPerformance_SectionHeader": "Antwortleistung",
    "AnswerPerformance_SectionPara": "Sie können auch die Schwellenwerte für die Zielantwortdauer spezifisch anpassen, die von den sieben Varianten der Leistungsstatistik für eingehende Antworten im Stil „Beantwortet < = Xs“ verwendet werden.",
    "NAME": "AnswerPerformance"
}